import React from 'react';

// @mui
import { TableCell, Tooltip, Typography } from '@mui/material';
import { fDateTime } from '../../utils/formatTime';
import i18n from '../../i18n';

export default class GridCreateModifyCell extends React.Component {
    render() {
        const { row, field } = this.props;
        const elements = Array.isArray(field?.elements) ? field.elements : [];
        const firstKey = elements[0] || null;
        const secondKey = elements[1] || null;

        let firstValue = null;
        let secondValue = null;

        if (firstKey && secondKey) {
            firstValue = row[firstKey] || null;
            secondValue = row[secondKey] || null;
        }


        const baseStyle = this.props.styles;


        return (
            <TableCell key={field.id} align="left" sx={{ gap: 1, ...baseStyle }}>
                {firstValue && secondValue ? (
                    <>
                        <Tooltip
                            title={i18n.t(`columns.${firstKey}`)}
                            placement="top-start"
                        >
                            <Typography variant="caption" component="div" noWrap>
                                {fDateTime(firstValue, 'd MMM yyyy HH:mm')}
                            </Typography>
                        </Tooltip>
                        {/* An unmodified record carries identical timestamps,
                            which is most rows — printing the same value twice
                            cost each of them a second line for no information.
                            Secondary weight when it does differ: the created
                            date is the one people scan by. */}
                        {secondValue !== firstValue && (
                            <Tooltip
                                title={i18n.t(`columns.${secondKey}`)}
                                placement="bottom-start"
                            >
                                <Typography
                                    variant="caption"
                                    component="div"
                                    color="text.secondary"
                                    noWrap
                                >
                                    {fDateTime(secondValue, 'd MMM yyyy HH:mm')}
                                </Typography>
                            </Tooltip>
                        )}
                    </>
                ) : (
                    '—'
                )}

            </TableCell>
        );
    }
}
